
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const NameAnalysisDeletePage = lazy(() => import('./NameAnalysisDelete'));
const path = 'reports/subword-frequency/delete';
const NameAnalysisDeleteRoute: FuseRouteItemType = {
	path: path,
	element: <NameAnalysisDeletePage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: true
				},
				toolbar: {
					title: 'Name Analysis for Delete',
					showCrumbs: false,
					helpName: 'Name Analysis for Delete'
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	}
};

export default NameAnalysisDeleteRoute;
